import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ItemInfoInputPanelView from "presentational/search/ItemInfoInputPanelView";
import {
  getFullUrl,
  getQueryObjFromUrl,
  getEssentialUrl
} from "lib/urlQueryParser";

import PropTypes from "prop-types";
// import LoungeSearchOptionGuideTooltipView from "presentational/lounge/LoungeSearchOptionGuideTooltipView";
/**
 * 랜딩 페이지의 검색옵션 툴팁 임시 제거
 * - 디자인 번잡하고 없어도 사용자경험 변화 없다고 판단되서
 */

const DEMO_QRY_ARR = [
  { category: "jeans", color: "skyblue" },
  { category: "shirts", color: "white" },
  { category: "shirts", color: "black" },
  { category: "regularpants", color: "ivory" },
  { category: "regularpants", color: "black" },
  { category: "boots", color: "black" }
];

LoungeSearchActionGroup.propTypes = {
  getNewList: PropTypes.func.isRequired
};

LoungeSearchActionGroup.defaultProps = {};

function LoungeSearchActionGroup(props) {
  const { getNewList } = props;
  const [queryCategory, setQueryCategory] = useState(undefined);
  const [queryBrand, setQueryBrand] = useState(undefined);
  const [queryColor, setQueryColor] = useState(undefined);
  const [queryTag, setQueryTag] = useState(undefined);
  const [queryGender, setQueryGender] = useState(undefined);
  const [readyToSubmit, setReadyToSubmit] = useState(false);
  // const [hasClickedAtLeastOnce, setHasClickedAtLeastOnce] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setInitQuery();
  }, []);
  useEffect(() => {
    if (readyToSubmit) {
      sendQryToParent();
      setReadyToSubmit(false);
    }
  }, [readyToSubmit]);

  const setInitQuery = () => {
    const nowUrlQryStr = window.location.search;
    const urlQryObj = getQueryObjFromUrl(nowUrlQryStr);

    if (!urlQryObj.category || !urlQryObj.gender) {
      const initValueArr =
        DEMO_QRY_ARR[Math.floor(Math.random() * DEMO_QRY_ARR.length)];
      changeInfo("category", initValueArr.category);
      changeInfo("color", initValueArr.color);
      changeInfo("gender", Math.random() * 2 > 1 ? "female" : "male");
    } else {
      for (const type in urlQryObj) {
        changeInfo(type, urlQryObj[type]);
      }
    }

    handleSubmit();
  };

  const changeInfo = async (type, value) => {
    switch (type) {
      case "category":
        setQueryCategory(value);
        break;
      case "brand":
        setQueryBrand(value);
        break;
      case "color":
        setQueryColor(value);
        break;
      case "tag":
        setQueryTag(value);
        break;
      case "gender":
        setQueryGender(value);
        break;

      default:
        break;
    }
  };

  const handleInfoChange = async (type, value) => {
    // setHasClickedAtLeastOnce(true);
    await changeInfo(type, value);
  };

  const handleSubmit = async () => {
    setReadyToSubmit(true);
  };

  const sendQryToParent = async () => {
    const queryObj = {
      category: queryCategory,
      brand: queryBrand,
      color: queryColor,
      tag: queryTag,
      gender: queryGender
    };
    getNewList(queryObj);

    const nextUrl = getFullUrl({
      url: getEssentialUrl({ type: "search", allowRefParam: true })(),
      queryObj: queryObj
    });
    history.replace(nextUrl);
  };

  return (
    <div style={{ display: "flex", flexDirection: "row-reverse" }}>
      {/* <LoungeSearchOptionGuideTooltipView
        hasClickedAtLeastOnce={hasClickedAtLeastOnce}
      > */}
      <ItemInfoInputPanelView
        nextQueryObj={{
          category: queryCategory,
          brand: queryBrand,
          color: queryColor,
          tag: queryTag,
          gender: queryGender
        }}
        onChange={handleInfoChange}
        onSubmit={handleSubmit}
        onOptionResetBtnClick={() => {}}
      />
      {/* </LoungeSearchOptionGuideTooltipView> */}
    </div>
  );
}

export default LoungeSearchActionGroup;
